import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFileService from "../utils/file-storage";
import Checkbox from "./ui/Checkbox";

export default () => {
  const { t } = useTranslation();
  const { remove } = useFileService();
  const { getValues, setValue } = useFormContext();
  const [loading, setLoading] = useState(false);
  const employeeId = getValues("employeeID");

  const onChange = async (e: any, value: boolean) => {
    if (!value) {
      const fileName = getValues("taxCoordFile");
      if (fileName) {
        setLoading(true);
        await remove(fileName, employeeId);
        setValue("taxCoordFile", undefined);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Checkbox
        label={t("PayslipEmailAgreement.message")}
        name="isPayslipEmailAllowed"
        onChange={onChange}
        disabled={loading}
        required
      />
    </>
  );
};
